import styled from "styled-components";
import { borderColorDADADA, disabledRoundBtnBg, disabledRoundBtnBorder, fontGreyColor, inlineWidth, mobileChangeWidth, orangeColor2 } from "../../styles/theme";

interface LinkAccountSectionProps {
    radius?: string;
    margin?: string;
    padding?: string;
}
export const LinkAccountSection = styled.div<LinkAccountSectionProps>`
    width: 100%;
    height: 100%;
    border: 1px solid ${borderColorDADADA};
    border-radius: ${(props) => props.radius ?? "8px"};  
    box-sizing: border-box;
    margin: ${(props) => props.margin ?? "0px"};
    padding: ${(props) => props.padding ?? "40px 50px"};
    @media only screen and (max-width: ${mobileChangeWidth}) {
        padding: ${(props) => props.padding ?? "40px 20px"};
    }
`;

interface FlexProps {
    justifyContent?: string;
    alignItems?: string;
    gap?: string;
    margin?: string;
    flexDirection?: string;
    changeFlexDirection?: string;
    changeJustifyContent?: string;
    changeAlignItems?: string;
}
export const Flex = styled.div<FlexProps>`
    width: 100%;
    margin: ${(props) => props.margin ?? "0px"};
    display: flex;
    flex-direction: ${(props) => props.flexDirection ?? "row"};
    justify-content: ${props => props.justifyContent ?? "start"};
    align-items: ${props => props.alignItems ?? "center"};
    gap: ${props => props.gap ?? "0px"};
    @media only screen and (max-width: ${mobileChangeWidth}) {
        flex-direction: ${(props) => props.changeFlexDirection};
        justify-content: ${(props) => props.changeJustifyContent};
        align-items: ${(props) => props.changeAlignItems};
    }
`;

interface SubTextProps {
    color?: string;
    fontSize?: string;
    fontWeight?: string;
    changeFontSize?: string;
    margin?: string;
}
export const SubText = styled.p<SubTextProps>`
    margin: ${(props) => props.margin ?? "0px"};
    color: ${props => props.color ?? `${fontGreyColor}`};
    font-size: ${props => props.fontSize ?? "1rem"};
    font-weight: ${props => props.fontWeight ?? "400"};
    @media only screen and (max-width: ${mobileChangeWidth}) {
        font-size: ${props => props.changeFontSize ?? "0.875rem"};
    }
`;

interface ToggleButtonProps {
    bgColor?: string;
    fontSize?: string;
    fontWeight?: string;
    changeFontSize?: string;
    margin?: string;
    borderRadius?: string;
    border?: string;
}
export const ToggleButton = styled.button<ToggleButtonProps>`
    width: 250px;
    box-sizing: border-box;
    background-color: ${props => props.bgColor ?? 'transparent'};
    border-radius: ${props => props.borderRadius ?? '0px'};
    color: ${props => props.color ?? `${fontGreyColor}`};
    font-size: ${props => props.fontSize ?? "1rem"};
    font-weight: ${props => props.fontWeight ?? "400"};
    border: ${props => props.border ?? `1px solid ${borderColorDADADA}`};
    padding: 10px 0px;
    cursor: pointer;
    @media only screen and (max-width: ${inlineWidth}) {
        font-size: ${props => props.changeFontSize ?? "0.875rem"};
    }
    @media only screen and (max-width: ${mobileChangeWidth}) {
        font-size: ${props => props.changeFontSize ?? "0.75rem"};
    }
`;

interface LineProps {
    marginTop?: string;
    marginBottom?: string;
}
export const Line = styled.div<LineProps>`
    margin-top: ${(props) => props.marginTop ?? "30px"};
    margin-bottom: ${(props) => props.marginBottom ?? "0px"};
    width: 100%;
    height: 1px;
    background-color: ${borderColorDADADA};
`;

interface RoundButtonProps {
    isDisabled?: boolean;
    fontSize?: string;
    borderRadius?: string;
    width?: string;
    height?: string;
    variant?: "filled" | "outlined"; // 추가
    changeFontSize?: string;
}

export const RoundButton = styled.button<RoundButtonProps>`
    flex-shrink: 0;
    align-self: stretch;
    box-sizing: border-box;
    background-color: ${(props) =>
        props.variant === "outlined"
            ? "#fff"
            : props.isDisabled
                ? `${disabledRoundBtnBg}`
                : `${orangeColor2}`};
    border: 1.5px solid
        ${(props) =>
        props.variant === "outlined"
            ? `${orangeColor2}`
            : props.isDisabled
                ? `${disabledRoundBtnBorder}`
                : `${orangeColor2}`};
    font-weight: 600;
    color: ${(props) =>
        props.variant === "outlined"
            ? `${orangeColor2}`
            : props.isDisabled
                ? `${disabledRoundBtnBorder}`
                : "#fff"};
    border-radius: ${(props) => props.borderRadius ?? "20px"};
    cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
    padding: 4px 16px;
    font-size: ${(props) => props.fontSize ?? "14px"};
    width: ${(props) => props.width ?? null};
    height: ${(props) => props.height ?? "40px"};
    transition: background 0.2s, color 0.2s;
    @media only screen and (max-width: ${mobileChangeWidth}) {
        font-size: ${(props) => props.changeFontSize};
    }
`;

export const EvWhereLogo = styled.img`
    width: 144px;
    @media only screen and (max-width: ${mobileChangeWidth}) {
        width: 100px;
    }
`;